import { DatabaseZap } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const DatabaseZapIcon = createLucideIcon(DatabaseZap);
